import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../config/firebase';

// List of authorized admin emails
const ADMIN_EMAILS = [
  'gurusankar149@gmail.com',  // Add your email here
  'writer2@example.com',
  // Add more authorized emails here
];

const AdminGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // Only redirect if we haven't checked auth status yet
        if (!checkedAuth) {
          const currentPath = location.pathname.substring(1); // Remove leading slash
          navigate(`/login?redirect=${currentPath}`);
        }
        setIsAuthorized(false);
      } else if (ADMIN_EMAILS.includes(user.email)) {
        setIsAuthorized(true);
      } else {
        setIsAuthorized(false);
        // Only redirect unauthorized users if they're not already on the login page
        if (!location.pathname.includes('/login')) {
          navigate('/');
        }
      }
      setCheckedAuth(true);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate, location, checkedAuth]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthorized && !loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h2>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminGuard; 